import UserProfile from '../../models/userProfile';

export const userProfile = new UserProfile();

// Make sure that our current user's profile instance is updated when/if we edit it in the system area:
userProfile.listenTo(dispatcher, 'system:user:edit:success', function (model) {
	model.id == userProfile.id && userProfile.fetch();
});

export default userProfile;

import {setGlobal} from '@netx/core-next/utils/setGlobal';
// circular dependency
// userProfile relies on this to determine if the profile being edited is the user editing it or not
// will get worked out as we continue switching out data sources
// if (process.env.NODE_ENV !== 'production') {
setGlobal({userProfile});
//}
